import {FiChevronLeft, FiChevronRight} from "react-icons/fi";

import {useCollapsiblePanelContext} from "@/components/collapsiblePanel/CollapsiblePanelContext.ts";
import {CollapsiblePanelToggleButtonProps} from "@/components/collapsiblePanel/subComponents/CollapsiblePanelToggleButton/CollapsiblePanelToggleButton.types.ts";
import {IconButton} from "@/components/iconButton/IconButton.tsx";

export const CollapsiblePanelToggleButton = ({
  action = "collapse",
  label = action === "collapse" ? "Collapse panel" : "Expand panel",
  className,
}: CollapsiblePanelToggleButtonProps) => {
  const {collapsed, collapse, expand} = useCollapsiblePanelContext();
  const isCollapse = action === "collapse";

  return (
    <IconButton
      icon={isCollapse ? FiChevronLeft : FiChevronRight}
      variant="ghost"
      size="small"
      aria-label={label}
      aria-expanded={!collapsed}
      title={label}
      onClick={isCollapse ? collapse : expand}
      className={className}
    />
  );
};
